import React from "react"
import { Grid, Stack, Typography } from "@mui/material"
import { LabeledField } from "./companyInfoComponents"
import CustomAutocomplete from "src/components/CustomAutocomplete"
import { type CompanyProfile } from "src/services/api/companyMembers"

interface EditMemberContactDetailsTabProps {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  profile: CompanyProfile | undefined
  errors: { firstName: boolean; lastName: boolean; email: boolean }
  readOnly: boolean
  isSelf: boolean
  onFirstNameChange: (value: string) => void
  onLastNameChange: (value: string) => void
  onEmailChange: (value: string) => void
  onPhoneNumberChange: (value: string) => void
  onProfileChange: (value: CompanyProfile | undefined) => void
}

export const EditMemberContactDetailsTab = ({
  firstName,
  lastName,
  email,
  phoneNumber,
  profile,
  errors,
  readOnly,
  isSelf,
  onFirstNameChange,
  onLastNameChange,
  onEmailChange,
  onPhoneNumberChange,
  onProfileChange
}: EditMemberContactDetailsTabProps) => {
  return (
    <Stack spacing={4} direction="column">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <LabeledField
            label="First Name *"
            value={firstName}
            error={errors.firstName}
            helperText={errors.firstName ? "Required" : undefined}
            onChange={(e) => onFirstNameChange(e.target.value)}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LabeledField
            label="Last Name *"
            value={lastName}
            error={errors.lastName}
            helperText={errors.lastName ? "Required" : undefined}
            onChange={(e) => onLastNameChange(e.target.value)}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LabeledField
            label="E-mail *"
            value={email}
            error={errors.email}
            helperText={errors.email ? "Required" : undefined}
            onChange={(e) => onEmailChange(e.target.value)}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LabeledField
            label="Phone number"
            value={phoneNumber}
            onChange={(e) => onPhoneNumberChange(e.target.value)}
            disabled={readOnly}
          />
        </Grid>
      </Grid>

      {profile && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Stack spacing={0.5}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Company Member Profile
              </Typography>
              <CustomAutocomplete<CompanyProfile>
                options={["MANAGER", "MEMBER"]}
                value={profile}
                getOptionLabel={(p) => (p === "MANAGER" ? "Manager" : "Member")}
                isOptionEqualToValue={(a, b) => a === b}
                onChange={(_, val) =>
                  onProfileChange(val === "MANAGER" || val === "MEMBER" ? val : undefined)
                }
                size="small"
                disabled={isSelf || readOnly}
              />
            </Stack>
          </Grid>
        </Grid>
      )}
    </Stack>
  )
}
